import { render, staticRenderFns } from "./SummaryDataList.vue?vue&type=template&id=71d408e8"
import script from "./SummaryDataList.vue?vue&type=script&lang=js"
export * from "./SummaryDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports